import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import City from '@components/offer/models/City';
import _ from 'lodash';
import { CircularProgress, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

interface CityDropdownProps {
    cities: City[];
    selectedCity: City;
    onCityChange: (city: City) => void;
    findCitiesFn: () => void;
}

const CityDropdown: React.FC<CityDropdownProps> = observer(({ cities, selectedCity, onCityChange, findCitiesFn }) => {
    const [isOpen, setIsOpen] = useState(false);
    const isLoading = isOpen && (_.isNil(cities) || cities.length === 0);

    useEffect(() => {
        if (isOpen && (_.isNil(cities) || cities.length === 0)) {
            const loadAsync = async () => {
                await findCitiesFn();
            }

            loadAsync();
        }
    }, [isOpen])

    const handleOnChange = (city: City) => {
        onCityChange(city);
        setIsOpen(false);
    };

    const handleOnClose = () => {
        setIsOpen(false);
    }

    const handleOnOpen = () => {
        setIsOpen(true);
    }

    return (
        <FormControl fullWidth sx={{ backgroundColor: "#fff", borderRadius: 1 }}>
            <Select
                id="city-select"
                open={isOpen}
                onOpen={handleOnOpen}
                onClose={handleOnClose}
                defaultValue={selectedCity.id}
                IconComponent={(props) => (
                    isLoading
                        ? <CircularProgress color="inherit" size={20} {...props} />
                        : <ArrowDropDownIcon {...props} />
                )}
            >
                {_.isNil(cities) || cities.length === 0
                    ? <MenuItem key={selectedCity.id} value={selectedCity.id}>{selectedCity.name}</MenuItem>
                    : _.map(cities, (city) => (
                        <MenuItem key={city.id} value={city.id} onClick={() => handleOnChange(city)}>{city.name}</MenuItem>
                    ))
                }
            </Select>
        </FormControl>
    )
})

export default CityDropdown;